import { useEffect, useRef, useState } from "react";
import { LuChevronLeft, LuX } from "react-icons/lu";
import blueWave from "../../../assets/blue_wave.mp4";
import { useIsUserSignedIn } from "../../../core_stores/useAuthStore";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";

export default function SubscriptionsModalLayout({
  children,
  onClose,
}: {
  children: React.ReactNode;
  onClose?: () => void;
}) {
  const isUserSignedIn = useIsUserSignedIn();

  const [isVisible, setIsVisible] = useState(false);
  const isCompactView = useIsCompactView();
  const closeTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setIsVisible(true);
    return () => {
      if (closeTimeout.current) clearTimeout(closeTimeout.current);
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    closeTimeout.current = setTimeout(() => {
      onClose?.();
    }, 200); // match transition duration
  };

  return (
    <div
      className={`${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      } ${!isCompactView && "p-4"} fixed inset-0 z-50 
      flex items-center justify-center
      transition-opacity duration-300
      bg-black/25 backdrop-blur-sm`}
      onClick={(e) => {
        if (!isCompactView && e.target === e.currentTarget) {
          handleClose();
        }
      }}
    >
      <div
        className={`${
          !isCompactView &&
          `max-w-[1200px] rounded-md ${
            isUserSignedIn ? "max-h-[625px]" : "max-h-[515px]"
          }`
        }
          relative 
        bg-light-surface-secondary dark:bg-dark-surface-secondary
      w-full h-full
      flex flex-col overflow-hidden
      shadow-[0_4px_14px_0_rgba(0,0,0,0.46)]`}
      >
        <div className="w-full h-[55%] overflow-hidden relative">
          <video
            src={blueWave}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="w-full h-full object-cover scale-[1.1]"
          />
          <div
            className="absolute h-[50%] left-0 right-0 bottom-0 bg-gradient-to-t 
              from-light-surface-secondary dark:from-dark-surface-secondary
              dark:via-dark-surface-secondary/75
              to-transparent pointer-events-none z-0"
          />
        </div>
        {children}
        <button
          className={`${isCompactView ? "left-4" : "right-4"}
            absolute top-4
          text-gray-300 hover:brightness-125 text-2xl
          transition-all duration-300`}
          onClick={handleClose}
          aria-label="Close"
        >
          {isCompactView ? <LuChevronLeft size={24} /> : <LuX size={24} />}
        </button>
      </div>
    </div>
  );
}
